import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Card } from '@/ui';
import { colors } from '@/theme/colors';
export const ProductCard = ({ product, onClick }) => {
    return (_jsxs(StyledProductCard, { variant: "elevated", hoverable: true, onClick: () => onClick?.(product), children: [_jsx(ImageContainer, { children: _jsx(ProductImage, { src: product.image, alt: product.name }) }), _jsx(CardContent, { children: _jsx(ProductName, { children: product.name }) })] }));
};
const StyledProductCard = styled(Card) `
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px ${colors.shadowDark};
  }
`;
const ImageContainer = styled.div `
  width: 100%;
  height: 200px;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
`;
const ProductImage = styled.img `
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  padding: 8px;
`;
const CardContent = styled.div `
  padding: 16px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const ProductName = styled.h3 `
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.textPrimary};
  line-height: 1.4;
  text-align: center;
`;
export default ProductCard;
